import type { QuestDefinition } from '@/types/quests';
import { TUTORIAL_01 } from './tutorial_01_old_pete';

const QUEST_REGISTRY: Record<string, QuestDefinition> = {
  tutorial_01: TUTORIAL_01,
};

export function getQuestDefinition(questId: string): QuestDefinition | undefined {
  return QUEST_REGISTRY[questId];
}

export function getTutorialQuestId(tutorialQuestNumber: number): string {
  return `tutorial_0${tutorialQuestNumber}`;
}
